import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from "firebase/app";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import( '../views/Home.vue'),
    meta: {
      requiresAuth: true
  }

  },
  {
    path: '/login',
    name:'login',
    component: () => import( '../views/Login.vue'),
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      isPublic: true
  },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/About.vue')
  },

  {
    path: '/settings',
    name: 'settings',
    component: () => import( '../views/settings.vue'),
    meta: {
      requiresAuth: true
  }
  },

  {
    path: '/public/:id',
    name: 'public',
    component: () => import('../views/publicPage.vue'), 
  },
  {
    path: '/firstPage',
    name: 'firstPage',
    component: () => import( '../views/firstPage.vue'),


  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async(to, from, next) => {
  // await store.default.dispatch('checkUserStatus')
  const currentUser = await firebase.getCurrentUser()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  //Route to requested page
  //Logged out user (login)
  if (requiresAuth && !currentUser) {
      next('firstPage')
  }
  //Logged in user
  else if (to.name === 'login'  && currentUser && !currentUser.isAnonymous) {
    next("/")
  }
  else if (to.name === 'firstPage'  && currentUser ) {
    next("/")
  }
  //Logged out user (login or landing page)
  else {
      next()
  }
});



export default router
